// Function to check if is a valid email
const isEmail = (email) => {
    // const emailRegex = /^[\w.-]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}$/;
    const emailRegex = /^[\w.-]+@[a-zA-Z_-]+(\.[a-zA-Z_-]+)+$/;
    return emailRegex.test(email);
}

export default isEmail;